import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {
    CampaignsServiceModuleName,
    ContactProfileModuleName,
    PartnerModuleName
} from "../utils/names/optionalModuleNames";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {PartnersController} from "./controller/root/PartnersController";
import {PartnersControllerName} from "../utils/names/serviceNames";
import {NavigationItem} from "../main/model/navigationItem";
import {getTabName} from "modules/utils/TabNameUtils";

export const PartnerModuleConfiguration = new RestrictedRouteModuleConfiguration(
    PartnerModuleName,
    [
        PartnerModuleName,
        CampaignsServiceModuleName,
        ContactProfileModuleName
    ],
    [
        ["/partners", {
            template: PartnersController.template,
            controller: PartnersControllerName
        }]
    ],
    [new NavigationItem({
        title: "Partners",
        href: "#!partners",
        activeFunction: (routeName) => {
            return routeName.indexOf("partners") !== -1;
        }
    })],
    [PartnerModuleName],
    [UserGranredAuthorityName.LEADS],
    getTabName() + '| Partner Profile'
);

export default PartnerModuleConfiguration;